import { global } from "../../constants";

export const data = {
  banner: {
    base: "服务",
    background: global.banner + "ofac.webp",
    title: "OFAC 许可证",
    crumb: "OFAC 许可证"
  },
  icon: "fa-solid fa-file-shield",
  shortDescription:
    "针对 OFAC 特定许可证申请的综合指南：确保与 PDVSA 及委内瑞拉能源行业相关交易的合规性。",
  title: "OFAC 许可证申请",
  features: {
    title: "OFAC 许可证申请",
    deliverables: "交付成果",
    reqDocuments: "所需文件",
    subtitle:
      "面向委内瑞拉能源行业及与 PDVSA 相关业务的合规概要与实务指南。",
    description:
      "在提交特定许可证申请之前，公司应先核实其业务是否已被 OFAC 一般许可证覆盖。即使某项业务可能符合一般许可证范围，PDVSA 在实践中通常仍要求交易对手在成交前持有特定许可证。因此，申请材料应围绕覆盖范围、参与方识别、业务范围、付款安排及支持文件进行清晰结构化。",
    viewDetail: "查看详情",
    feats: [
      {
        key: "licencias-generales",
        title: "适用一般许可证核验",
        summary:
          "我们确认拟开展活动是否已被现行一般许可证覆盖，以避免不必要或方向错误的申请。",
        details:
          "我们将业务性质与可能适用于委内瑞拉能源行业的一般许可证进行比对评估，包括石油采购与出口、勘探和生产相关货物/技术/服务供应、美国来源稀释剂销售以及附条件合同谈判等情形。分析会明确区分已授权活动、明示限制以及仍需单独特定许可证的场景。",
        deliverables: [
          "现行一般许可证覆盖性分析",
          "一般许可证与特定许可证的论证性建议",
          "OFAC 监管风险报告",
        ],
        requiredDocs: [
          "拟议活动或交易说明",
          "美国公司注册成立日期",
          "拟提供货物、服务或技术的性质",
        ],
        icon: "fa-solid fa-shield-halved",
        image: global.ofac + "1.webp",
      },
      {
        key: "solicitante",
        title: "美国申请人信息",
        summary:
          "我们按照 OFAC 要求收集并结构化整理申请人的公司信息。",
        details:
          "申请材料需准确识别申请人信息：法定名称与商业名称、注册州及成立日期、主要办公地址与注册地址、联邦税号、董事及负责人身份、重要持股的最终受益人、公司组织架构，以及参与该交易的任何海外关联公司或子公司。",
        deliverables: [
          "申请人完整公司档案",
          "结构化公司组织架构图",
          "最终受益人及董事名单",
        ],
        requiredDocs: [
          "公司注册证明及章程",
          "董事与股东身份证明文件",
          "子公司及关联实体公司记录",
        ],
        icon: "fa-solid fa-building",
        image: global.ofac + "2.webp",
      },
      {
        key: "contraparte-terceros",
        title: "交易对手及第三方识别",
        summary:
          "我们梳理 PDVSA、其关联公司、中介机构、银行、承运商及交易各阶段涉及的所有参与方。",
        details:
          "申请文件必须全面识别主要交易对手及全部第三方参与者，包括关联公司、合资企业、代表、代理、中介、金融机构、运输/物流公司、分包商、服务提供商，以及在交易中承担任何角色的委内瑞拉政府机构。",
        deliverables: [
          "交易参与方关系图谱",
          "与受制裁实体关联性分析",
          "第三方尽职调查报告",
        ],
        requiredDocs: [
          "与 PDVSA 或其关联公司的合同或沟通文件",
          "金融机构及银行账户信息",
          "相关供应商、承运商和代理信息",
        ],
        icon: "fa-solid fa-sitemap",
        image: global.ofac + "3.webp",
      },
      {
        key: "naturaleza-alcance",
        title: "业务性质与范围",
        summary:
          "明确涉及的货物、服务或技术，以及其期限、金额和地域/运营范围。",
        details:
          "本部分需记录拟向 PDVSA 提供或从其接收的货物、服务或技术的详细描述、行业分类、商业关系形成背景、是否已签署合同、预计交易金额、履约期限、执行里程碑、交付计划以及服务实施或活动发生的地理位置。",
        deliverables: [
          "用于申请的交易叙述说明",
          "合同时间表与关键里程碑",
          "技术与商业范围执行摘要",
        ],
        requiredDocs: [
          "与 PDVSA 的合同草案或已签合同",
          "货物或服务技术规格",
          "初步进度计划或已约定商业条款",
        ],
        icon: "fa-solid fa-file-contract",
        image: global.ofac + "4.webp",
      },
      {
        key: "condiciones-pago",
        title: "付款条款与资金流",
        summary:
          "说明资金如何流转、使用何种币种、通过何种支付工具以及涉及哪些银行或金融中介。",
        details:
          "OFAC 通常要求对付款机制作出清晰说明，例如电汇、信用证、抵销、易货或实物支付。申请材料还应包含付款币种、可能的汇兑机制、付款与收款账户、参与银行、SWIFT 代码及与该交易相关的任何资金结构。",
        deliverables: [
          "标注参与机构的资金流向图",
          "付款机制与适用币种摘要",
          "银行、账户及金融参与方矩阵",
        ],
        requiredDocs: [
          "所有付款实体的完整银行信息",
          "付款指令或财务条款草案",
          "代理行信息及 SWIFT 代码",
        ],
        icon: "fa-solid fa-money-bill-transfer",
        image: global.ofac + "5.webp",
      },
      {
        key: "geografia-documentacion",
        title: "地理范围、物流与支持文件",
        summary:
          "统筹交易的地域与物流要素，并整理支撑申请的文件包。",
        details:
          "需说明服务实施地点、涉及的港口/航线/国家，以及是否存在向第三国出口原油或衍生品的安排。同时应汇总支持性材料，包括公司文件、合同或合同草案、技术规格、资金流向图、既往 OFAC 许可证及必要的认证译文。",
        deliverables: [
          "涵盖港口、航线与国家的运营物流图",
          "完整、编号且有序的附件文件包",
          "OFAC 提交文件清单",
        ],
        requiredDocs: [
          "运输路线及相关港口文件",
          "申请人既往 OFAC 许可证（如有）",
          "支持文件的英文认证翻译件",
        ],
        icon: "fa-solid fa-earth-americas",
        image: global.ofac + "6.webp",
      },
    ],
  },
  ctaText: "申请 OFAC 咨询",
  ctaLink: "/contacto?servicio=licencia-ofac",
};